var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0H2a2 2 0 00-2 2v14a2 2 0 002 2h3.586a1 1 0 01.707.293l2 2a1 1 0 001.414 0l2-2a1 1 0 01.707-.293H16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-4.86 4.9c-.57-.523-1.317-.784-2.24-.784-.608 0-1.144.117-1.61.35a2.547 2.547 0 00-1.065.994c-.252.42-.378.91-.378 1.47h1.204c0-.541.163-.966.49-1.274.336-.317.793-.476 1.372-.476.57 0 1.022.163 1.358.49.336.327.504.77.504 1.33 0 .775-.261 1.302-.784 1.582s-1.246.42-2.17.42h-.406l.056 2.212h1.106l.042-1.33c1.036 0 1.857-.233 2.464-.7.607-.476.91-1.204.91-2.184 0-.877-.285-1.577-.854-2.1zM7.4 13.832a.838.838 0 00.616.252c.233 0 .43-.084.588-.252a.838.838 0 00.252-.616.838.838 0 00-.252-.616.777.777 0 00-.588-.252.838.838 0 00-.616.252.838.838 0 00-.252.616c0 .243.084.448.252.616z",
    fill: "#001B28"
  })));
}

export default SvgQuestion;